import React from 'react'

interface IconProps {
  name?: string
  size?: 'small' | 'normal' | 'medium' | 'large' | 'big' | string
  color?: string
  variant?: string
  children?: React.ReactNode
}

export const Icon: React.FC<IconProps> = ({ name, children }) => {
  return <span style={{ display: 'inline-block' }}>{children || name}</span>
}
